import {
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  ButtonProps,
  ModalProps,
  ModalContentProps,
  ModalHeaderProps,
  ModalBodyProps,
} from "@chakra-ui/react";
import React from "react";

export interface TimesUpModalProps {
  modalProps?: ModalProps;
  modalContentProps?: ModalContentProps;
  modalHeaderProps?: ModalHeaderProps;
  modalBodyProps?: ModalBodyProps;
  modalStartOverButtonProps?: ButtonProps;
  modalGoToHomeButtonProps?: ButtonProps;
}

function TimesUpModal({
  isOpen,
  onClose,
  handleStartOver,
  modalProps,
  modalContentProps,
  modalHeaderProps,
  modalBodyProps,
  modalStartOverButtonProps,
  modalGoToHomeButtonProps,
}: {
  isOpen: boolean;
  onClose: () => void;
  handleStartOver?: () => void;
} & TimesUpModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
      {...modalProps}
    >
      <ModalOverlay />
      <ModalContent {...modalContentProps}>
        <ModalHeader {...modalHeaderProps}>Time&apos;s Up!</ModalHeader>
        <ModalBody {...modalBodyProps}>
          <Text>
            Your seat booking time has ended. Would you like to start over or
            return home?
          </Text>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button
            variant="outline"
            onClick={() => {
              handleStartOver ? handleStartOver() : window.location.reload();
              onClose();
            }}
            {...modalStartOverButtonProps}
          >
            Start Over
          </Button>
          <Button
            backgroundColor={"primary.500"}
            onClick={() => {
              window.location.assign("/");
              onClose();
            }}
            {...modalGoToHomeButtonProps}
          >
            Go to Home
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default TimesUpModal;
